<template>
  <a
    class="ss__desktop__menu__good__item"
    :href="item.url"
    :target="item.blank ? '_blank' : '_self'">
    <img
      :src="$formatImageSrc(item.image, { w: 240, h: 240 }) || $app.imgErrorSrc"
      :alt="item.name"
      class="ss__desktop__menu__good__item__image"
    />
    <div class="ss__desktop__menu__good__item__name">{{ item.name }}</div>
    <div class="ss__desktop__menu__good__item__desc">{{ item.description }}</div>
    <div class="ss__desktop__menu__good__item__price__wrapper">
      <span class="ss__desktop__menu__good__item__price">¥{{ item.price / 100 | round(2, 'number') }}</span>
      <del
        v-if="item.originPrice && item.price !== item.originPrice"
        class="ss__desktop__menu__good__item__price--del">¥{{ item.originPrice / 100 | round(2, 'number') }}</del>
    </div>
    <div
      v-if="item.memberPrice && item.price !== item.memberPrice"
      class="ss__desktop__menu__good__item__price--forPrime">
      <i class="ssCommunityIcon__prime"/>
      <span>¥{{ item.memberPrice / 100 | round(2, 'number') }}</span>
    </div>
  </a>
</template>

<script>

export default {
  name: 'SsDesktopMenuGoodItem',

  props: {
    item: Object
  }
}
</script>

<style lang="stylus" scoped>
.ss__desktop__menu__good__item {
  .ss__desktop__menu__good__item__image {
    width: var(--w-SsDesktopMenuGoodItemImage, 120px);
    height: var(--h-SsDesktopMenuGoodItemImage, 120px);
    border-radius: var(--radius-SsDesktopMenuGoodItemImage, 8px);
    border: var(--border-SsDesktopMenuGoodItemImage, (1px solid rgba(0, 0, 0, 0.05)));
    margin: var(--margin-SsDesktopMenuGoodItemImage, (0px 0px 8px));
    object-fit: cover;
    box-sizing: border-box;
  }

  .ss__desktop__menu__good__item__name {
    width: var(--h-SsDesktopMenuGoodItemName, 120px);
    font-size: var(--text-SsDesktopMenuGoodItemName, 13px);
    font-weight: var(--wight-SsDesktopMenuGoodItemName, 500);
    margin: var(--margin-SsDesktopMenuGoodItemName, (0px 0px 4px));
    color: var(--color-SsDesktopMenuGoodItemName, var(--B8-t));
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .ss__desktop__menu__good__item__desc {
    width: var(--h-SsDesktopMenuGoodItemDesc, 120px);
    font-size: var(--text-SsDesktopMenuGoodItemDesc, 13px);
    font-weight: var(--wight-SsDesktopMenuGoodItemDesc, 500);
    margin: var(--margin-SsDesktopMenuGoodItemDesc, (0px 0px 4px));
    color: var(--color-SsDesktopMenuGoodItemDesc, var(--B6-t));
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .ss__desktop__menu__good__item__price {
    font-size: var(--text-SsDesktopMenuGoodItemPrice, 13px);
    font-family: var(--font-SsDesktopMenuGoodItemPrice, 'Outfit-Medium');
    font-weight: var(--weight-SsDesktopMenuGoodItemPrice, 500);
    margin: var(--margin-SsDesktopMenuGoodItemPrice, (0 4px 0 0));
    color: var(--color-SsDesktopMenuGoodItemPrice, var(--red-t));
  }

  .ss__desktop__menu__good__item__price--del {
    font-size: var(--text-SsDesktopMenuGoodItemPrice--del, 13px);
    font-family: var(--font-SsDesktopMenuGoodItemPrice--del, 'Outfit-Regular');
    font-weight: var(--weight-SsDesktopMenuGoodItemPrice--del, 400);
    margin: var(--margin-SsDesktopMenuGoodItemPrice--del, 0);
    color: var(--color-SsDesktopMenuGoodItemPrice--del, var(--B5-t));
  }

  .ss__desktop__menu__good__item__price--forPrime {
    display: flex;
    align-items center;
    font-size: var(--text-SsDesktopMenuGoodItemPrice--forPrime, 13px);
    font-family: var(--font-SsDesktopMenuGoodItemPrice--forPrime, 'Outfit-Medium');
    font-weight: var(--weight-SsDesktopMenuGoodItemPrice--forPrime, 500);
    margin: var(--margin-SsDesktopMenuGoodItemPrice--forPrime, (4px 0 0 0));
    color: var(--color-SsDesktopMenuGoodItemPrice--forPrime, var(--prime));
    .ssCommunityIcon__prime {
      font-size: var(--size---color-SsDesktopMenuGoodItemPrimeIcon, 16px);
      margin: var(--margin-SsDesktopMenuGoodItemPrimeIcon, (0 2px 0 0));
    }
  }
}
</style>
